import { render, staticRenderFns } from "./divider-direction-editor.vue?vue&type=template&id=5f4a51a1&scoped=true&"
import script from "./divider-direction-editor.vue?vue&type=script&lang=js&"
export * from "./divider-direction-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a51a1",
  null
  
)

export default component.exports